import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main
      data-testid="page-not-found"
      className="pt-32 pb-24 container-x min-h-[70vh] flex flex-col items-start justify-center"
    >
      <div className="font-mono-label text-xs text-[#00F0FF] mb-4">/ 404</div>
      <h1 className="font-display text-6xl md:text-7xl text-white tracking-tight">
        Signal lost.
      </h1>
      <p className="mt-6 text-white/60 max-w-md">
        The page you&apos;re looking for isn&apos;t here. Head home and try again.
      </p>
      <Link
        to="/"
        data-testid="not-found-home"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#00F0FF] text-black font-semibold px-5 py-2.5"
      >
        Back to home
      </Link>
    </main>
  );
}
